import React from 'react'
import { Box } from 'rebass'
import { theme } from 'theme'

const BoxMask: React.FC<{ opacity?: number }> = ({ opacity = 0.4 }) => (
    <Box
        bg={theme.newColors.neutral50}
        width="100%"
        height="100%"
        sx={{ position: 'absolute', top: 0, left: 0, zIndex: 99, opacity }}
    />
)

export default BoxMask
